import api from "../../../api/api";


const getBatchList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("/fms/barcode/batch/list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const generateBarcode = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/fms/barcode/generate",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getByBatchId = (id) =>{
    return new Promise((resolve, reject)=>{
        api.get("/fms/barcode/list/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const searchDocumentByBarcode = (barcode) =>{
    return new Promise((resolve, reject)=>{
        api.get("/fms/document/barcode/"+barcode).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const barcodeServices = {
    getBatchList,
    generateBarcode,
    getByBatchId,
    searchDocumentByBarcode
}
export default barcodeServices;